<template>
    <div>
        <div class="feature-description"> 
            <p v-html="body"></p>
            <Tooltip v-if="tooltip" class="feature-description-tooltip" :content="tooltip" />
        </div>
    </div>
</template>
  
<script>
import Tooltip from './Tooltip.vue';

export default {
    name: "FeatureDescription",
    components: { Tooltip },
    props: ["content"],
    data() {
        const [body, tooltip] = this.content.split('|');

        return {
            body,
            tooltip
        }
    }
};
</script>
  
<style lang="scss">
 
.feature-description {
    display: flex;
    align-items: center;
    justify-content: center;
}

.feature-description-tooltip {
    margin-left: 5px;
}

@media (max-width: $bp-mobile) {
    .feature-description {
        background-color: #FFF;
        color: $color-primary;
    }
}
</style>
  